exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] .EFyOT1AabHFHgOhH8FsSQ{padding-top:14px}.EFyOT1AabHFHgOhH8FsSQ ._13LJcjhGPYWqb0PILhSWdK{font-size:17px;font-weight:300}html[dir] .EFyOT1AabHFHgOhH8FsSQ ._2yz2g2wKDe8xdv5GZsKUxn{margin:8px 0 15px}html[dir] .EFyOT1AabHFHgOhH8FsSQ ._3MRJYCV77yJiVcwuhBadr9{margin-bottom:20px}html[dir=ltr] ._2qdA645mwvInvLxaqy0r7D{margin-left:8px}html[dir=rtl] ._2qdA645mwvInvLxaqy0r7D{margin-right:8px}", ""]);

// exports
exports.locals = {
	"calendarUpdatesWrapper": "EFyOT1AabHFHgOhH8FsSQ",
	"sectionTitle": "_13LJcjhGPYWqb0PILhSWdK",
	"sectionMessage": "_2yz2g2wKDe8xdv5GZsKUxn",
	"sectionCheckboxesMessage": "_3MRJYCV77yJiVcwuhBadr9",
	"coloredBullet": "_2qdA645mwvInvLxaqy0r7D"
};